import { WelcomePageGuard } from 'new-components/WelcomePageGuard/WelcomePageGuard';
import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { getOpParams } from 'utils/getOpParams';
import { OpTermsGuard } from 'new-components/OpAppScaffold/components/OpTermsGuard';
import { getControlCenterOrigin } from 'utils/getControlCenterOrigin';
import { requiredTermsRoute } from 'routes/constants';

import { sosWelcomeRoute } from '../../constants/routes';

export const SosWelcomePageGuard = () => {
  const { orgId } = getOpParams();
  const { data: org, isPending: isLoadingOrg } = useOpQuery({
    apiEndpointName: 'describeOrg',
    parameters: [orgId, { options: 'withSosFacilityOrg' }],
    select: (heliumResponse) => heliumResponse?.json?.data,
  });

  const hasAssociatedFacilityOrg = Boolean(org?.sosFacilityOrg);

  const accessTermsUrl = `${getControlCenterOrigin()}/o/${orgId}/${requiredTermsRoute}`;

  return (
    <WelcomePageGuard
      shouldShowWelcomePage={!hasAssociatedFacilityOrg}
      welcomePagePath={sosWelcomeRoute}
      isLoading={isLoadingOrg}
    >
      <OpTermsGuard url={accessTermsUrl} isExternal />
    </WelcomePageGuard>
  );
};
